import { Box, FormHelperText, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AttachmentRegistStatus,
  FormClassRetire,
  FormKbn,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkStepper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkAmountInput from "../../components/molecules/TkAmountInput";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkSalaryAdjustmentModal from "../../components/molecules/TkSalaryAdjustmentModal";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_STA008_Request } from "../../type/apiType";
import { changeAmountFormat, toNumberOrUndefined } from "../../utils/useTools";
import "./_style.scss";
import { httpAPI_BUS002, httpAPI_STA008 } from "./api/request";
import {
  fakeTableList,
  fakeTableListFile,
  salaryTableHead,
  stepper,
} from "./parts";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { API_STA008_BuildReqParams } from "../../utils/buildRequestParams";
import _ from "lodash";

/**
 * SCRC060123 退職情報　登録（本俸月額の登録）
 * @return SCRC060123 退職情報　登録（本俸月額の登録）
 */
const SCRC060123 = () => {
  const navigate = useNavigate();

  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [stateInfoListFile, setStateInfoListFile] = useState<any>([]);
  const stateInfoFakeTableListFile = useRef(_.cloneDeep(fakeTableListFile));
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_32;
  // ダイアログ開閉状態（明細）
  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
  // ダイアログ開閉状態（合計）
  const [isOpenDialogSum, setIsOpenDialogSum] = useState<boolean>(false);
  // ダイアログ開閉状態（合計）
  const [isOpenSaveDialog, setIsOpenSaveDialog] = useState<boolean>(false);
  const [currentItemIndex, setCurrentItemIndex] = useState<number>(0);
  const [infoBodyList, setInfoBodyList] = useState<any>([]);
  const [wagesFlg, setWagesFlg] = useState<boolean>(false);
  const [newList, setNewList] = useState<any[]>([]);
  const [allowanceList, setAllowanceList] = useState<
    { label: string; value: string }[]
  >([]);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo!
    : state.authInfo?.contractorNo!;
  const [selectedList, setSelectedList] = useState<any>([]);
  const [selectValues, setSelectValues] = useState<{ [key: number]: string }>(
    {}
  );
  const [inputValues, setInputValues] = useState<{ [key: number]: number }>({});
  const [total, setTotal] = useState<number>(0);
  useEffect(() => {
    const allowanceList: any = [];
    (businessState.job_32?.salaryAdjustmentAllowanceList ?? []).forEach(
      (allowance) => {
        allowanceList.push({
          label: allowance.allowanceName,
          value: allowance.allowanceHisSerialNo,
        });
        setAllowanceList(allowanceList);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOpenDialog || isOpenDialogSum) {
      setSelectValues(selectedList[currentItemIndex]?.selectValues ?? {});
      setTotal(selectedList[currentItemIndex]?.total);
      if (
        Object.keys(selectedList[currentItemIndex]?.inputValues).length !== 0 &&
        Object.values(selectedList[currentItemIndex]?.inputValues).every(
          (value) => value === undefined
        )
      ) {
        setInputValues({ 0: selectedList[currentItemIndex]?.total });
      } else {
        setInputValues(selectedList[currentItemIndex]?.inputValues ?? {});
      }
      if (
        Object.keys(selectedList[currentItemIndex]?.selectValues).length ===
          0 &&
        Object.keys(selectedList[currentItemIndex]?.inputValues).length === 0 &&
        total !== 0
      ) {
        setSelectedList((prevData: any) =>
          prevData.map((obj: any, index: any) =>
            index === 0
              ? {
                  ...obj,
                  inputValues: { 0: selectedList[currentItemIndex]?.total },
                }
              : obj
          )
        );
        setInputValues({ 0: selectedList[currentItemIndex]?.total });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenDialog, isOpenDialogSum, currentItemIndex]);

  useEffect(() => {
    let retireDate = new Date(context?.retireDate!);
    let retireYear = retireDate.getFullYear();
    let month = retireDate.getMonth() + 1;
    let lastDate = new Date(retireYear, month, 0);
    let startMonth =
      retireDate.toDateString() === lastDate.toDateString() ? month : month - 1;

    let sixMonth: any = [];
    context?.sixMonthsSalaryBeforeApplySettingList?.forEach((item) => {
      let date =
        toNumberOrUndefined(
          retireYear + startMonth.toString().padStart(2, "0")
        ) ?? 0;

      if (item.unaccountedMonth === "1") return;
      if (item.yearMonth! > date) return;
      if (sixMonth.length === 6) return;

      let detailList = item.salaryApplyDetailList?.map((i) => {
        return { ...i, yearMonth: item.yearMonth };
      });
      let allowances = item.salaryApplyDetailList?.map((item) =>
        context?.salaryAdjustmentAllowanceList?.find(
          (i) => i.allowanceHisSerialNo === item.allowanceHisSerialNo
        )
      );

      let data = {
        yearMonth: item.yearMonth,
        salaryTableAmt: item.salaryTableAmt,
        salaryTableAmtDef: item.salaryTableAmt,
        detailList,
        allowanceName: allowances?.map((i) => i?.allowanceName)?.join("、"),
        salaryAdjustmentAmt: item.salaryAdjustmentAmt,
        errorMsg: "",
        selectErrorMsg: "",
      };

      sixMonth.push(data);
    });

    if (businessState.common?.businessType === "JOB-33") {
      sixMonth = sixMonth.filter((_: any, i: any) => i === 0);
    }

    setNewList(sixMonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (newList.length > 0) {
      let infoList: any = newList.map((data, index) => {
        let selectValues: any = {};
        let inputValues: any = {};
        data.detailList?.forEach((d: any, i: any) => {
          selectValues[i] = d.allowanceHisSerialNo;
          inputValues[i] = d.adjustmentAmt;
        });
        setSelectedList((prev: any) => {
          prev.splice(index, 1, {
            selectValues,
            inputValues,
            total: data.salaryAdjustmentAmt,
          });
          return prev;
        });

        let dataInfo: any = [
          {
            children: `${data.yearMonth
              ?.toString()
              ?.slice(0, 4)}年${data.yearMonth.toString().slice(4, 6)}月`,
            align: "center",
          },
          {
            children: (
              <TkAmountInput
                error={!!data.errorMsg}
                errorMessage={data.errorMsg}
                wantToSetValue={data.salaryTableAmtDef}
                inputProps={{ maxLength: 9 }}
                onChange={(event) => handleBlur(index, event)}
              />
            ),
            align: "right",
          },
          {
            children: data.allowanceName,
          },
          {
            children: changeAmountFormat(data.salaryAdjustmentAmt ?? 0) + "円",
            align: "right",
          },
          {
            children: (
              <Box className="allowanceInputOuter">
                <Box className="allowanceInput">
                  <TkButton
                    onClick={() => {
                      setIsOpenDialog(true);
                      setCurrentItemIndex(index);
                    }}
                  >
                    明細
                  </TkButton>
                  または
                  <TkButton
                    onClick={() => {
                      setIsOpenDialogSum(true);
                      setCurrentItemIndex(index);
                    }}
                  >
                    合計
                  </TkButton>
                </Box>
                <FormHelperText error>
                  {data.selectErrorMessage ? data.selectErrorMessage : ""}
                </FormHelperText>
              </Box>
            ),
          },
        ];
        return dataInfo;
      });
      setInfoBodyList(infoList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newList]);

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    if (isUserTypeKiko) {
      let contractorName = resArr.find(
        (item) => item.keyword === "contractorName"
      )!;
      contractorName.showLine = true;
      contractorName.contractorNumber = `${businessState.common?.contractorNo}:${businessState.common?.contractorName}`;
    }
    resArr.find((item) => item.keyword === "staffNo")!.text =
      businessState.job_32?.staffNo;
    resArr.find((item) => item.keyword === "retireeName")!.text =
      businessState.job_32?.staffNameKanji;

    let resArrFile = stateInfoFakeTableListFile.current;
    businessState.job_32?.formList?.forEach((item) => {
      if (
        item.formKbn === FormKbn["退職書類"] &&
        item.formClass === FormClassRetire["賃金台帳"]
      ) {
        let wages = resArrFile.find((item) => item.keyword === "wages")!;
        setWagesFlg(true);
        wages.showLine = true;
        wages.setDefaultValue = [
          {
            serialNo: item.serialNo, //連番
            facilityNo: item.facilityNo, //施設番号
            staffNo: item.staffNo, //職員番号
            formKbn: item.formKbn, //帳票区分
            formClass: item.formClass, //帳票種別
            formName: item.fileName ?? item?.formName, //帳票名
            attachDocRegStatus: item.attachDocRegStatus, //添付状態
            fileBase64: item.fileBase64, //ファイル（base64）
          },
        ];
      }
      if (
        item.formKbn === FormKbn["退職書類"] &&
        item.formClass === FormClassRetire["雇用契約書"]
      ) {
        setWagesFlg(true);
        let contractOfEmployment = resArrFile.find(
          (item) => item.keyword === "contractOfEmployment"
        )!;
        contractOfEmployment.showLine = true;
        contractOfEmployment.setDefaultValue = [
          {
            serialNo: item.serialNo, //連番
            facilityNo: item.facilityNo, //施設番号
            staffNo: item.staffNo, //職員番号
            formKbn: item.formKbn, //帳票区分
            formClass: item.formClass, //帳票種別
            formName: item.fileName ?? item?.formName, //帳票名
            attachDocRegStatus: item.attachDocRegStatus, //添付状態
            fileBase64: item.fileBase64, //ファイル（base64）
          },
        ];
      }
    });
    setStateInfoListFile([...resArrFile]);
    setStateInfoList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArrFile = stateInfoFakeTableListFile.current;
    resArrFile.find((item) => item.keyword === "wages")!.showLine = wagesFlg
      ? true
      : false;
    resArrFile.find(
      (item) => item.keyword === "contractOfEmployment"
    )!.showLine = wagesFlg ? true : false;
    setStateInfoListFile([...resArrFile]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wagesFlg]);

  const handleSave = (data: {
    total: string;
    inputValues: { [key: number]: string | undefined };
    selectValues: { [key: number]: number };
  }) => {
    if (currentItemIndex !== null) {
      setNewList((prevList) =>
        prevList.map((item, index) => {
          if (index === currentItemIndex) {
            let detailList = [];
            for (let i in data.selectValues) {
              detailList.push({
                allowanceHisSerialNo: data.selectValues[i],
                adjustmentAmt: data.inputValues[i],
              });
            }
            return {
              ...item,
              salaryAdjustmentAmt: data.total,
              detailList: detailList,
              selectErrorMessage: "",
              allowanceName: Object.values(data.selectValues)
                .map(
                  (item) =>
                    context?.salaryAdjustmentAllowanceList?.find(
                      (i) => i.allowanceHisSerialNo === item
                    )?.allowanceName
                )
                .join("、"),
            };
          } else {
            return item;
          }
        })
      );
    }
  };

  const handleBlur = (index: number, event: any) => {
    setNewList((prevList) =>
      prevList.map((item, i) => {
        if (i === index) {
          let updatedItem = {
            ...item,
            salaryTableAmt: event.target.value,
          };

          if (event.target.value > 999999999) {
            updatedItem.errorMsg = TkPropertyMessageGet(
              "TKMSG_SCR0048E",
              "999,999,999"
            );
          } else if (event.target.value !== 0 && !event.target.value) {
            updatedItem.errorMsg = TkPropertyMessageGet("TKMSG_SCR0043E");
          } else {
            updatedItem.errorMsg = "";
          }

          return updatedItem;
        } else {
          return item;
        }
      })
    );
  };

  // ユーザタイプ
  const userType = state?.authInfo?.userType;
  // ユーザタイプが機構
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;

  const makeHttpObj = (data: any) => {
    const newFileList: any =
      businessState.job_32?.formList?.filter(
        (item) =>
          !(
            item.formKbn === FormKbn["退職書類"] &&
            (item.formClass === FormClassRetire["賃金台帳"] ||
              item.formClass === FormClassRetire["雇用契約書"])
          )
      ) ?? [];
    if (data?.contractOfEmployment?.length > 0) {
      let emptyFile = {
        serialNo: 1,
        staffNo: businessState.job_32?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["雇用契約書"],
        formName: data.contractOfEmployment[0].formName ?? "",
        fileBase64: data.contractOfEmployment[0].fileBase64 ?? "",
        attachDocRegStatus: AttachmentRegistStatus["登録済"],
      };
      newFileList.push(emptyFile);
    }
    if (data?.wages?.length > 0) {
      let emptyFile = {
        serialNo: newFileList.length + 1,
        staffNo: businessState.job_32?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["賃金台帳"],
        formName: data.wages[0].formName ?? "",
        fileBase64: data.wages[0].fileBase64 ?? "",
        attachDocRegStatus: AttachmentRegistStatus["登録済"],
      };
      newFileList.push(emptyFile);
    }

    const sixMonthsSalaryBeforeApplyList = newList.map((item) => ({
      yearMonth: item.yearMonth,
      salaryTableAmt: item.salaryTableAmt,
      salaryAdjustmentAmt: item.salaryAdjustmentAmt,
    }));

    const sixMonthsSalaryBeforeApplyDetailList: any = [];
    newList.forEach((item) => {
      item.detailList?.forEach((i: any) => {
        sixMonthsSalaryBeforeApplyDetailList.push({
          yearMonth: item.yearMonth,
          allowanceHisSerialNo: +i?.allowanceHisSerialNo,
          adjustmentAmt: +i?.adjustmentAmt,
        });
      });
    });

    const reqObj: IAPI_STA008_Request = {
      ...businessState.job_32,
      contractorNo: isUserTypeKiko
        ? businessState.common?.contractorNo
        : state.authInfo?.contractorNo, // 共済契約者番号
      tempSaveStep: 4, // 一時保存ステップ
      businessType:
        businessState.job_32?.nRetireReasonCd !== "1"
          ? "JOB-31"
          : businessState.job_32?.retireProcedureReason === "13" &&
            businessState.job_32?.continueTransferApplicable1Flg === "1" &&
            businessState.job_32?.continueTransferApplicable2Flg === "1"
          ? "JOB-33"
          : "JOB-32", // 業務タイプ
      sixMonthsSalaryBeforeApplyList: sixMonthsSalaryBeforeApplyList, // 申請前6か月本俸月額の調整額明細リスト
      sixMonthsSalaryBeforeApplyDetailList:
        sixMonthsSalaryBeforeApplyDetailList, // 申請前6か月本俸月額の調整額明細リスト
      formList: newFileList, // 帳票情報リスト
      updateDateTime: context?.updateDateTime, // 更新日時
      screenId: "SCRC060123", // 画面id
    };

    return API_STA008_BuildReqParams(reqObj);
  };

  //業務チェック
  const businessCheck = () => {
    // 画面で入力された6ヶ月の「俸給表の額」の金額の入力パターンが3種類以上の場合
    const checked: any[] = [];
    newList.forEach((item) => {
      const count = checked.findIndex((obj) => obj === item.salaryTableAmt);
      count === -1 && checked.push(item.salaryTableAmt);
    });
    if (checked.length >= 3) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0004W",
      });
      return true;
    }
    // 持回情報.申請手当名リストの入出力項目.俸給の調整額において、入力されている月と入力されていない月がある場合
    if (
      !newList.every((item) => !item.salaryAdjustmentAmt) &&
      newList.some((item) => !item.salaryAdjustmentAmt)
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0016W",
      });
      return true;
    }

    // 以下の①と②を算出し、②÷①が25%よりも大きい場合
    // ①持回情報.申請手当名リストの「入出力項目.俸給表の額」６か月の平均額を算出
    let salaryTableAmtSum = 0;
    (newList ?? []).forEach((data) => {
      salaryTableAmtSum += toNumberOrUndefined(data.salaryTableAmt) ?? 0;
    });
    // ②持回情報.申請手当名リストの「入出力項目.俸給の調整額」６か月の平均額を算出
    let adjustmentAmtSum = 0;
    (newList ?? []).forEach((data) => {
      adjustmentAmtSum += toNumberOrUndefined(data.salaryAdjustmentAmt) ?? 0;
    });
    if (
      adjustmentAmtSum / newList.length / (salaryTableAmtSum / newList.length) >
      0.25
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0017W",
      });
      return true;
    }
    setState({
      ...state,
      errorMsgId: "",
    });
    return false;
  };

  const onSaveSubmit = async (data: any, index: any) => {
    let list = _.cloneDeep(newList);
    let hasError = false;
    // 俸給表の額が未入力の場合
    const emptyAmount = list.find(
      (item) => !item.salaryTableAmt && item.salaryTableAmt !== 0
    );
    if (!!emptyAmount) {
      list = list.map((item) =>
        !item.salaryTableAmt && item.salaryTableAmt !== 0
          ? {
              ...item,
              errorMsg: TkPropertyMessageGet("TKMSG_SCR0043E"),
            }
          : item
      );
      hasError = true;
    }
    // 手当名が未選択で俸給の調整額がある場合
    if (list.some((item) => !item.allowanceName && item.salaryAdjustmentAmt)) {
      list = list.map((item) =>
        !item.allowanceName && item.salaryAdjustmentAmt
          ? {
              ...item,
              selectErrorMessage: TkPropertyMessageGet("TKMSG_SCR0044E"),
            }
          : item
      );
      hasError = true;
    }
    if (hasError) {
      setNewList(list);
      return;
    }

    if (newList?.find((newData) => newData?.salaryTableAmt <= 73999)) {
      // 俸給表の額 ≦ 73,999円
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0124E",
      });
      return;
    }
    const sixMonthsSalaryBeforeApplyList = newList.map((item) => ({
      yearMonth: item.yearMonth,
      salaryTableAmt: item.salaryTableAmt,
      salaryAdjustmentAmt: item.salaryAdjustmentAmt,
    }));

    const sixMonthsSalaryBeforeApplyDetailList: any = [];
    newList.forEach((item) => {
      item.detailList?.forEach((i: any) => {
        sixMonthsSalaryBeforeApplyDetailList.push({
          yearMonth: item.yearMonth,
          allowanceHisSerialNo: +i?.allowanceHisSerialNo,
          adjustmentAmt: +i?.adjustmentAmt,
        });
      });
    });

    let sixMonthsSalaryBeforeApplySettingList =
      context?.sixMonthsSalaryBeforeApplySettingList?.map((item) => {
        let inputData = newList?.find((i) => i.yearMonth === item.yearMonth);

        if (inputData) {
          return {
            yearMonth: item.yearMonth,
            unaccountedMonth: "0",
            salaryTableAmt: inputData.salaryTableAmt,
            salaryAdjustmentAmt: inputData.salaryAdjustmentAmt,
            salaryApplyDetailList: inputData.detailList,
          };
        }
        return item;
      });
    newList?.forEach((item, index) => {
      if (
        context?.sixMonthsSalaryBeforeApplySettingList?.[0]?.yearMonth! <
        item.yearMonth
      ) {
        let data = {
          yearMonth: item.yearMonth,
          unaccountedMonth: "0",
          salaryTableAmt: item.salaryTableAmt,
          salaryAdjustmentAmt: item.salaryAdjustmentAmt,
          salaryApplyDetailList: item.detailList,
        };
        sixMonthsSalaryBeforeApplySettingList?.splice(index, 0, data);
      }
    });
    if (index === 0) {
      // 一時保存
      // 退職者詳細情報更新API 呼び出し
      try {
        const res = await httpAPI_STA008({
          ...makeHttpObj(data),
        });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });
          setBusinessState({
            ...businessState,
            job_32: {
              ...businessState.job_32,
              tempSaveStep: 4,
              applyId: toNumberOrUndefined(res?.applyId),
              updateDateTime: res?.updateDateTime,
              sixMonthsSalaryBeforeApplyList,
              sixMonthsSalaryBeforeApplyDetailList,
              formList: makeHttpObj(data).formList?.map((i) => {
                return {
                  ...i,
                  formName: i.fileName ?? "",
                  attachDocRegStatus: i.formStatus,
                };
              }),
              sixMonthsSalaryBeforeApplySettingList,
            },
          });
          setIsOpenSaveDialog(true);
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      // 次へ
      const nowError = newList.find((item) => !!item.errorMsg);
      if (!!nowError) return;
      if (!data?.wages || data?.wages?.length === 0) {
        const checkError = businessCheck();
        if (checkError) {
          setWagesFlg(true);
          return;
        }
        try {
          const salaryApplyList = newList.map((item) => ({
            salaryTableAmt: item.salaryTableAmt,
            salaryAdjustmentAmt: item.salaryAdjustmentAmt,
          }));
          const res = await httpAPI_BUS002({
            checkedList: [],
            salaryTableList: salaryApplyList, // 6か月本俸リスト
            contractorNo: contractorNo,
            staffNo: businessState.job_32?.staffNo,
            retireDate: businessState.job_32?.retireDate,
          });

          if (res.resultCd !== "I0000") {
            setWagesFlg(true);
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
            return;
          }
        } catch (error) {
          navigate("/error");
        }
      }

      setBusinessState({
        ...businessState,
        job_32: {
          ...businessState.job_32,
          sixMonthsSalaryBeforeApplyList,
          sixMonthsSalaryBeforeApplyDetailList,
          formList: makeHttpObj(data).formList?.map((i) => {
            return {
              ...i,
              formName: i.fileName ?? "",
              attachDocRegStatus: i.formStatus,
            };
          }),
          sixMonthsSalaryBeforeApplySettingList,
        },
      });
      setState({
        ...state,
        errorMsgId: "",
      });
      if (businessState.common?.businessType === "JOB-33") {
        navigate("/SCRC060028");
      } else {
        navigate("/SCRC060124");
      }
    }
  };

  return (
    <Box data-testid="SCRC060123test" className="SCRC060123">
      <TkStepper
        steps={stepper}
        activeStep={3}
        savaStep={businessState.job_32?.tempSaveStep}
      />

      <Box className="explain">
        <TkInfoManual>{labelids.labelid.LBLC060123_01}</TkInfoManual>
        <TkHelpIcon
          helpMessage={
            <>
              「退職した月以前６か月の本俸月額」の表示されている年月においては、「ならない月」と退職日が月末でない場合の「退職月」を除いて表示しています。
              <br />
              また、表示されている本俸月額、俸給の調整額は、直近で更新された額を初期値として６か月分表示しています。
            </>
          }
        />
      </Box>

      <TkFakeTable list={stateInfoList} ruleSchema={{}} showButton={false} />

      <Typography className="tableTitle">俸給状況</Typography>
      <TkTable headList={salaryTableHead} bodyList={infoBodyList} />

      <TkFakeTable
        list={stateInfoListFile}
        ruleSchema={{}}
        onCheckAndSubmit={(data, index) => {
          onSaveSubmit(data, index);
        }}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
      />

      <TkSalaryAdjustmentModal
        open={isOpenDialog}
        selectPropsList={allowanceList}
        onSave={(data) => {
          setIsOpenDialog(false);
          handleSave(data);
        }}
        onClose={() => setIsOpenDialog(false)}
        wantToSetValue={selectedList[currentItemIndex]}
        selectedBtn={"STATEMENT"}
        selectValues={selectValues}
        setSelectValues={setSelectValues}
        inputValues={inputValues}
        setInputValues={setInputValues}
        total={total}
        setTotal={setTotal}
      />

      <TkSalaryAdjustmentModal
        open={isOpenDialogSum}
        showEachAmount={false}
        selectPropsList={allowanceList}
        onSave={(data) => {
          setIsOpenDialogSum(false);
          handleSave(data);
        }}
        onClose={() => setIsOpenDialogSum(false)}
        wantToSetValue={selectedList[currentItemIndex]}
        selectedBtn="TOTAL"
        selectValues={selectValues}
        setSelectValues={setSelectValues}
        inputValues={inputValues}
        setInputValues={setInputValues}
        total={total}
        setTotal={setTotal}
      />

      <TkMessageDialog
        open={isOpenSaveDialog}
        onOky={() => setIsOpenSaveDialog(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060123;
